module.exports = __webpack_public_path__ + "img/antes_despues_190.072cf524.png";